import CurrencyInput, { CurrencyInputProps } from "react-currency-input-field";
import { useEffect, useState } from "react";
import { InputContainer } from "./styles";

function InputMoney({
  value,
  onChange,
  isInvalid,
  maxValue = Number.MAX_SAFE_INTEGER,
  minValue = 0,
  backgroundColor,
  allowUndefined = false,
  ...props
}: {
  value: any;
  isInvalid?: boolean;
  onChange: (v: number | undefined) => any;
  maxValue?: number;
  minValue?: number;
  backgroundColor?: string;
  allowUndefined?: boolean;
} & Omit<CurrencyInputProps, "onChange">) {
  const [localValue, setLocalValue] = useState<string | undefined>(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    if (
      allowUndefined &&
      (localValue === "" || localValue === undefined) &&
      localValue !== value
    ) {
      onChange(undefined);
    } else if (value < minValue || value > maxValue) {
      const nextValue = Math.min(Math.max(value, minValue), maxValue);

      onChange(nextValue);
      setLocalValue(`${nextValue.toFixed(2)}`);
    }
  }, [allowUndefined, localValue, maxValue, minValue, onChange, value]);

  return (
    <InputContainer
      isInvalid={isInvalid}
      backgroundColor={backgroundColor}
      disabled={props.disabled}
    >
      <CurrencyInput
        value={localValue}
        groupSeparator="."
        decimalSeparator=","
        // intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
        decimalsLimit={2}
        decimalScale={2}
        className="chakra-input"
        placeholder="0,00"
        style={{
          textAlign: "right",
        }}
        {...props}
        onValueChange={(c, name, values) => {
          const nextValue =
            c && Number.isInteger(Number(c))
              ? Math.min(Math.max(Number(c), minValue), maxValue)
              : c;

          setLocalValue(nextValue?.toString());
          if (
            values?.float &&
            values.float >= minValue &&
            values?.float <= maxValue
          ) {
            onChange(values?.float);
          } else if (!values?.float) {
            onChange(0);
          }
        }}
      />
    </InputContainer>
  );
}

export default InputMoney;
